import type { App } from 'vue';
import { orderBy } from 'lodash-es';
import axios from 'axios';

const isActive = !!process.env.VUE_APP_STATUS_PAGE_API_URL;

interface StatusIncident {
    title: string;
    text: string;
    impact: string;
    impactValue: number;
    status: string;
    components: string[];
    type: string;
}

export default {
    installed: false,

    install(app: App) {
        if (this.installed) {
            return;
        }

        this.installed = true;

        const statusPage = {
            async fetch(): Promise<StatusIncident[]> {
                if (!isActive) {
                    return [];
                }

                const incidents: StatusIncident[] = [];
                const [responseMaintenances, responseIncidents] = await Promise.all([
                    axios.get(
                        `${process.env.VUE_APP_STATUS_PAGE_API_URL}/scheduled-maintenances/active.json`
                    ),
                    axios.get(
                        `${process.env.VUE_APP_STATUS_PAGE_API_URL}/incidents/unresolved.json`
                    ),
                ]);

                if (responseMaintenances.status == 200) {
                    responseMaintenances.data.scheduled_maintenances.forEach((maintenance: any) => {
                        incidents.push({
                            ...maintenance,
                            type: 'maintenance',
                        });
                    });
                }

                if (responseIncidents.status == 200) {
                    responseIncidents.data.incidents.forEach((maintenance: any) => {
                        incidents.push({ ...maintenance, type: 'incident' });
                    });
                }

                return orderBy(
                    incidents.map((incident: any) => {
                        return {
                            title: incident.name,
                            text: incident.incident_updates[0].body,
                            impact: incident.impact,
                            impactValue: [
                                'none',
                                'minor',
                                'maintenance',
                                'major',
                                'critical',
                            ].indexOf(incident.impact),
                            status: incident.status,
                            components: incident.components.map((component: any) => component.name),
                            type: incident.type,
                        };
                    }),
                    'impactValue',
                    'desc'
                );
            },
        };

        app.config.globalProperties.$statusPage = statusPage;
    },
};
